module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADmSURBVEiJ7dY9SgNhGATgmffduJ0mF5CEoDcwWGhhk1PZid5IkBQ2FiIWniAseIGs6ZLvZ2xcLMRu18ZvDjAPTDUEgKZpzsM+X0tYShqhx5AMZnyowNvZ6eyF6/X7WQzhWZL3Cf2EEc2rRZVivJPkdX2A8eQI7tYrlFJGu/nAbrevlPONSboCMAgGAO6G8eQQACBpad2UQ2DfqHfgaDjllxSwgAUsYAELWMB/AZKMAJBSGgzpuklEE/AIAG27RUp5ACyj3Wy/QF/96RGuvVrYfH78au6X5nZPMvQPMZB8ovnF9GT69gmw4WEtZuFkGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/public/components/kye-canvas-table/images/checkdisable.png
// module id = AMwz
// module chunks = 4